import styled from 'styled-components';
import { P } from '@workramp/ui';

export const HubspotUpsellFormWrapper = styled.div`
  ul {
    list-style-type: none;
    padding-left: 0;
    margin-top: 0;
    font-size: ${({ theme }) => theme.typography.generateFontSize(0)}px;
    .hs-error-msg {
      color: ${({ theme }) => theme.colors.danger[500]};
      list-style-type: none;
      padding-left: 0;
      margin-top: 0;
    }
  }

  .hs-input.invalid.error {
    border-color: ${({ theme }) => theme.colors.danger[500]};
  }
  .hs-input.invalid.error {
    border-color: ${({ theme }) => theme.colors.danger[500]};
  }

  input[type='text'],
  input[type='email'] {
    width: 90%;
    height: 40px;
    color: ${({ theme }) => theme.colors.on[900]};
    background-color: ${({ theme }) => theme.colors.surface[0]};
    border: 1px solid ${({ theme }) => theme.colors.on[100]};
    border-radius: ${({ theme }) => theme.radii.xl}px;
    outline-color: transparent;
    padding-left: ${({ theme }) => theme.spacing(4)}px;
    padding-right: ${({ theme }) => theme.spacing(4)}px;
    margin-bottom: ${({ theme }) => theme.spacing(4)}px;
  }

  input[type='submit'] {
    border-radius: ${({ theme }) => theme.radii.lg}px;
    height: ${({ theme }) => theme.spacing(6)}px;
    line-height: ${({ theme }) => theme.spacing(8)}px;
    padding-left: ${({ theme }) => theme.spacing(3)}px;
    padding-right: ${({ theme }) => theme.spacing(3)}px;
    padding-top: 0px;
    border-width: 1px;
    background-color: ${({ theme }) => theme.colors.primary[600]};
    border-color: ${({ theme }) => theme.colors.primary[600]};
    color: #ffffff;
    font-size: ${({ theme }) => theme.typography.generateFontSize(1)}px;
    height: 40px;
    line-height: 40px;
    vertical-align: middle;
    width: 100%;
  }
`;

export const Description = styled(P)`
  margin-bottom: ${({ theme }) => theme.spacing(4)}px;
`;
